let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fqkMC")).then(() => parcelRequire('bA5Ka'));